var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.247 1.3879C31.4842 0.60498 31.247 0.0355866 30.1964 0.0355866H26.7057C25.8245 0.0355866 25.4178 0.533808 25.1806 1.06762C25.1806 1.06762 23.3844 5.62277 20.8765 8.57651C20.0631 9.4306 19.6903 9.71531 19.2498 9.71531C19.0125 9.71531 18.7075 9.43061 18.7075 8.64769V1.35231C18.7075 0.427045 18.4364 0 17.6908 0H12.2006C11.6583 0 11.3194 0.427044 11.3194 0.85409C11.3194 1.74377 12.5734 1.9573 12.7089 4.4484V9.85765C12.7089 11.032 12.5056 11.2455 12.065 11.2455C10.8788 11.2455 7.99814 6.65481 6.26973 1.42349C5.93083 0.391459 5.59192 0 4.71077 0H1.18617C0.169452 0 0 0.498219 0 1.03203C0 1.99288 1.18617 6.83274 5.52414 13.2384C8.40483 17.6157 12.5056 19.9644 16.1996 19.9644C18.4364 19.9644 18.7075 19.4306 18.7075 18.5409V15.2313C18.7075 14.1637 18.9109 13.9858 19.6226 13.9858C20.1309 13.9858 21.046 14.2705 23.1133 16.3701C25.4856 18.8612 25.8923 20 27.214 20H30.7047C31.7214 20 32.1959 19.4662 31.9248 18.4342C31.6198 17.4021 30.4675 15.9075 28.9763 14.1281C28.1629 13.1317 26.9429 12.0285 26.5701 11.4947C26.0617 10.7829 26.1973 10.4982 26.5701 9.85765C26.5362 9.85765 30.8064 3.52313 31.247 1.3879Z",
    fill: "#121258"
  })));
}

export default SvgVk;